{
  "version": 1,
  "asset_id": "e5741d1e-c307-462d-bdae-9d2e52331922",
  "project_id": "9fb22223-732b-4b0d-9eac-b115ce8cfd9c",
  "url": "/__l5e/assets-v1/e5741d1e-c307-462d-bdae-9d2e52331922/hostpoint.svg",
  "r2_key": "a/v1/9fb22223-732b-4b0d-9eac-b115ce8cfd9c/e5741d1e-c307-462d-bdae-9d2e52331922/hostpoint.svg",
  "original_filename": "hostpoint.svg",
  "size": 4278,
  "content_type": "image/svg+xml",
  "created_at": "2026-06-16T14:53:55Z"
}
